import { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { IntakeContext } from 'context/IntakeContext'
// import { Link } from "react-router-dom";

// @mui material components
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import Box from '@mui/material/Box'

// Soft UI Dashboard PRO React components

// Soft UI Dashboard PRO React icons
import CalculateIcon from '@mui/icons-material/Calculate'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import AssessmentIcon from '@mui/icons-material/Assessment'
import AssignmentIcon from '@mui/icons-material/Assignment'
import HelpIcon from '@mui/icons-material/Help'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import SquareRoundedIcon from '@mui/icons-material/SquareRounded'
import SavingsIcon from '@mui/icons-material/Savings'
import { selectData } from 'layouts/onboarding'

const StyledMSB = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: ${(props) =>
    props.active ? '2px solid #a3a7aa' : '2px solid #e5e5e5'};
  background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
  color: #212121;
  border-radius: 0.75rem;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    border: 2px solid #a3a7aa;
    background: #f5f5f5;
  }

  > h6,
  h5 {
    color: #212121;
    letter-spacing: 0.3px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
  }

  > span {
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.yesIcon {
      color: #4caf50;
      background-color: #dbefdc;
    }
    &.noIcon {
      color: #fd5c70;
      background-color: #fedee2;
    }
  }
`
export const DeductionTypeSelection = () => {
  const { nonUserState, setNonUserState } = useContext(IntakeContext)
  const [selectedDeductions, setSelectedDeductions] = useState(
    nonUserState?.deductionTypesToInput || []
  )
  const { deductionTypes } = selectData
  const toggleSelectedDeduction = (deductionValue) => {
    let updatedDeductionSelections = []
    const deductionsIndex = selectedDeductions.findIndex(
      (value) => value === deductionValue
    )
    if (deductionsIndex === -1) {
      updatedDeductionSelections = [...selectedDeductions, deductionValue]
      setSelectedDeductions(updatedDeductionSelections)
    } else {
      updatedDeductionSelections = [...selectedDeductions]
      updatedDeductionSelections.splice(deductionsIndex, 1)
      setSelectedDeductions(updatedDeductionSelections)
    }
    setNonUserState((prevState) => ({
      ...prevState,
      deductionTypesToInput: updatedDeductionSelections,
    }))
  }

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box mt={2}>
        <Grid container spacing={1} justifyContent="center" mb={3}>
          {deductionTypes.map(({ value, label }) => {
            return (
              <Grid item xs={6} sm={4} key={value}>
                <StyledMSB
                  active={selectedDeductions.indexOf(value) !== -1}
                  onClick={() => toggleSelectedDeduction(value)}
                >
                  <Typography variant="h5" textTransform="capitalize">
                    {label}
                  </Typography>
                </StyledMSB>
              </Grid>
            )
          })}
        </Grid>
      </Box>
    </Box>
  )
}
